var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 7.53093L11.6359 2.5001H8.60502C7.50045 2.5001 6.60502 3.39553 6.60502 4.5001V12.1359C6.60502 13.2405 7.50045 14.1359 8.60502 14.1359H14.6668C15.7713 14.1359 16.6668 13.2405 16.6668 12.1359V7.53093ZM11.6359 2.5001V5.53093C11.6359 6.6355 12.5314 7.53093 13.6359 7.53093H16.6668M6.25599 5.89518H5.33344C4.22887 5.89518 3.33344 6.79061 3.33344 7.89518V15.5001C3.33344 16.6047 4.22887 17.5001 5.33343 17.5001H11.3334C12.438 17.5001 13.3334 16.6047 13.3334 15.5001V14.568",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fa372ec2c584e6ce312561dbf1b80e9a.svg";
export { ForwardRef as ReactComponent };